import { IconCalendar, IconPercent, IconPound } from '@iwoca/icons';

import styles from './FormalOfferCard.module.css';
import {
  getDurationInMonths,
  getProductName,
} from '../../helpers/product.helpers';
import { useNumberFormat } from '../../hooks/useNumberFormat';
import { TGetFormalOffersResponse } from '../../types';

type TProps = Pick<
  TGetFormalOffersResponse['data']['formal_offers'][number],
  | 'product_type'
  | 'duration'
  | 'max_amount'
  | 'interest_rates'
  | 'withdrawal_fee_percentage'
>;

const FormalOfferCard = ({
  product_type,
  duration,
  max_amount,
  interest_rates,
  withdrawal_fee_percentage,
}: TProps) => {
  const { formatCurrency, formatPercentage } = useNumberFormat();

  return (
    <div className={styles.container}>
      <h3 className={styles.heading}>{getProductName(product_type)}</h3>
      <ul className={styles.detailsList}>
        <li className={styles.detailsListItem}>
          <IconCalendar
            data-testid="calendar-icon"
            width={20}
            height={20}
            className={styles.itemIcon}
          />
          Term length:{' '}
          <span className={styles.detailValue}>
            {getDurationInMonths(duration)}
            {' months'}
          </span>
        </li>
        <li className={styles.detailsListItem}>
          <IconPound
            data-testid="pount-icon"
            width={20}
            height={20}
            className={styles.itemIcon}
          />
          Offer amount:{' '}
          <span className={styles.detailValue}>
            {formatCurrency(max_amount)}
          </span>
        </li>
        <li className={styles.detailsListItem}>
          <IconPercent
            data-testid="percent-icon"
            width={20}
            height={20}
            className={styles.itemIcon}
          />
          Interest rate:{' '}
          <span className={styles.detailValue}>
            {formatPercentage(interest_rates[0].rate)}
          </span>
        </li>
        {withdrawal_fee_percentage ? (
          <li className={styles.detailsListItem}>
            <IconPercent
              data-testid="percent-icon"
              width={20}
              height={20}
              className={styles.itemIcon}
            />
            Withdrawal fee:{' '}
            <span className={styles.detailValue}>
              {formatPercentage(withdrawal_fee_percentage)}
            </span>
          </li>
        ) : null}
      </ul>
    </div>
  );
};
export default FormalOfferCard;
